import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import LeadershipPage from "./pages/LeadershipPage";
import CareersPage from "./pages/CareersPage";
import TestIndexPage from "./pages/TestIndexPage";
import InsurancePage from "./pages/InsurancePage";
import PatientInsurancePage from "./pages/PatientInsurancePage";
import BillingPage from "./pages/BillingPage";
import LogisticsPage from "./pages/LogisticsPage";
import MedicalNecessityPage from "./pages/MedicalNecessityPage";
import PortalAccessPage from "./pages/PortalAccessPage";
import AnnualNoticePage from "./pages/AnnualNoticePage";
import ContactPage from "./pages/ContactPage";
import FindPatientResultsPage from "./pages/FindPatientResultsPage";
import MakeAnAppointmentPage from "./pages/MakeAnAppointmentPage";
import PatientBillingPage from "./pages/PatientBillingPage";
import PrivacyNoticePHIPage from "./pages/PrivacyNoticePHIPage";
import WebsitePrivacyPolicyPage from "./pages/WebsitePrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import AccessibilityPage from "./pages/AccessibilityPage";
import LabAcquisitionsPage from "./pages/LabAcquisitionsPage";
import NewsroomPage from "./pages/NewsroomPage";
import NewsletterLabariumMeaningPage from "./pages/NewsletterLabariumMeaningPage";
import LicensesPage from "./pages/LicensesPage";
import LabariumIntelligencePage from "./pages/LabariumIntelligencePage";
import ChatWidget from "./components/ChatWidget";

const ROUTES = {
  "home":                     HomePage,
  "about-us":                 AboutPage,
  "leadership-team":          LeadershipPage,
  "careers":                  CareersPage,
  "test-index":               TestIndexPage,
  "insurance":                InsurancePage,
  "patient-insurance":        PatientInsurancePage,
  "billing-and-coding":       BillingPage,
  "logistics":                LogisticsPage,
  "medical-necessity":        MedicalNecessityPage,
  "portal-access":            PortalAccessPage,
  "annual-notice":            AnnualNoticePage,
  "contact-us":               ContactPage,
  "find-patient-results":     FindPatientResultsPage,
  "make-an-appointment":      MakeAnAppointmentPage,
  "patient-billing":          PatientBillingPage,
  "phi-privacy-notice":       PrivacyNoticePHIPage,
  "website-privacy-policy":   WebsitePrivacyPolicyPage,
  "terms-of-use":             TermsOfUsePage,
  "accessibility":            AccessibilityPage,
  "lab-acquisitions":         LabAcquisitionsPage,
  "newsroom":                 NewsroomPage,
  "labarium-origin":          NewsletterLabariumMeaningPage,
  "licenses":                 LicensesPage,
  "labarium-intelligence":    LabariumIntelligencePage,
};

const GLOBAL_CSS = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; overflow-x: hidden; }
  body {
    font-family: 'Inter', 'Barlow', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #ffffff;
    color: #0d1b2e;
    overflow-x: hidden;
  }
  button, a, select, input, textarea { font-family: 'Inter', 'Barlow', sans-serif; }

  /* Scrollbar */
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: #f0f3f9; }
  ::-webkit-scrollbar-thumb { background: #c9a96e; border-radius: 3px; }

  /* ── Keyframe animations ── */
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(40px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes slideInLeft {
    from { opacity: 0; transform: translateX(-32px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  @keyframes slideInRight {
    from { opacity: 0; transform: translateX(32px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  @keyframes scaleIn {
    from { opacity: 0; transform: scale(0.92); }
    to   { opacity: 1; transform: scale(1); }
  }
  @keyframes drift1 {
    0%,100% { transform: translateY(0px); }
    50%      { transform: translateY(-10px); }
  }
  @keyframes drift2 {
    0%,100% { transform: translateY(0px); }
    50%      { transform: translateY(-8px); }
  }
  @keyframes drift3 {
    0%,100% { transform: translateY(0px); }
    50%      { transform: translateY(-6px); }
  }
  @keyframes spinSlow {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position: 200% center; }
  }
  @keyframes glowPulse {
    0%,100% { opacity: 0.6; }
    50%      { opacity: 1; }
  }
  @keyframes tickerScroll {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
  }
  @keyframes lineGrow {
    from { transform: scaleX(0); }
    to   { transform: scaleX(1); }
  }
  @keyframes dropdownOpen {
    from { opacity: 0; transform: translateY(-8px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes borderGlow {
    0%,100% { border-color: rgba(201,169,110,0.3); }
    50%      { border-color: rgba(201,169,110,0.7); }
  }
  @keyframes ecgScroll {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
  }
  @keyframes ecgScrollFast {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
  }
  @keyframes dotBounce {
    0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
    40%            { transform: translateY(-8px); opacity: 1; }
  }
  @keyframes chatSlideUp {
    from { opacity: 0; transform: translateY(24px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes pulseRing {
    0%   { transform: scale(1); opacity: 0.6; }
    100% { transform: scale(1.9); opacity: 0; }
  }

  /* ── Scroll-reveal utility ── */
  .reveal {
    opacity: 0;
    transform: translateY(36px);
    transition: opacity 0.75s cubic-bezier(.4,0,.2,1), transform 0.75s cubic-bezier(.4,0,.2,1);
  }
  .reveal.visible { opacity: 1; transform: translateY(0); }
  .reveal-left {
    opacity: 0; transform: translateX(-32px);
    transition: opacity 0.75s cubic-bezier(.4,0,.2,1), transform 0.75s cubic-bezier(.4,0,.2,1);
  }
  .reveal-left.visible { opacity: 1; transform: translateX(0); }
  .reveal-right {
    opacity: 0; transform: translateX(32px);
    transition: opacity 0.75s cubic-bezier(.4,0,.2,1), transform 0.75s cubic-bezier(.4,0,.2,1);
  }
  .reveal-right.visible { opacity: 1; transform: translateX(0); }
  .reveal-scale {
    opacity: 0; transform: scale(0.94);
    transition: opacity 0.75s cubic-bezier(.4,0,.2,1), transform 0.75s cubic-bezier(.4,0,.2,1);
  }
  .reveal-scale.visible { opacity: 1; transform: scale(1); }

  /* Stagger delays */
  .delay-100 { transition-delay: 0.1s !important; }
  .delay-200 { transition-delay: 0.2s !important; }
  .delay-300 { transition-delay: 0.3s !important; }
  .delay-400 { transition-delay: 0.4s !important; }
  .delay-500 { transition-delay: 0.5s !important; }
  .delay-600 { transition-delay: 0.6s !important; }

  /* Card hover lift */
  .card-lift {
    transition: transform 0.35s cubic-bezier(.4,0,.2,1), box-shadow 0.35s cubic-bezier(.4,0,.2,1) !important;
  }
  .card-lift:hover {
    transform: translateY(-8px) !important;
    box-shadow: 0 24px 64px rgba(0,30,80,0.18) !important;
  }

  /* Shimmer button */
  .btn-shimmer {
    background-size: 200% auto !important;
    transition: background-position 0.5s ease, transform 0.25s ease, box-shadow 0.25s ease !important;
  }
  .btn-shimmer:hover {
    background-position: right center !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 10px 36px rgba(201,169,110,0.45) !important;
  }

  /* Glass card */
  .glass {
    background: rgba(255,255,255,0.07) !important;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
  }

  /* ─── Responsive layout utilities ──────────────────────────────────────── */
  /* !important lets these override inline style props at each breakpoint    */

  .hero-badges   { display: flex !important; }
  .stat-grid     { display: grid !important; grid-template-columns: repeat(4, 1fr) !important; }
  .three-col     { display: grid !important; grid-template-columns: repeat(3, 1fr) !important; }
  .two-col       { display: grid !important; grid-template-columns: 1fr 1fr !important; }
  .appt-grid     { display: grid !important; grid-template-columns: 1fr 1.6fr !important; gap: 48px !important; }
  .form-grid     { display: grid !important; grid-template-columns: 1fr 1fr !important; }
  .hours-grid    { display: grid !important; grid-template-columns: 1fr 1px 1fr !important; gap: 64px !important; align-items: center !important; position: relative !important; z-index: 1 !important; }
  .hours-divider { display: block !important; }
  .footer-grid   { display: grid !important; grid-template-columns: 2.4fr 1fr 1fr 1fr 1fr !important; gap: 48px !important; }
  .rx-pad        { padding-left: 40px !important; padding-right: 40px !important; }

  /* Large laptop / small desktop (≤ 1280px) */
  @media (max-width: 1280px) {
    .footer-grid { grid-template-columns: 1fr 1fr 1fr !important; gap: 36px !important; }
  }

  /* Tablet (≤ 1024px) */
  @media (max-width: 1024px) {
    .hero-badges   { display: none !important; }
    .stat-grid     { grid-template-columns: repeat(2, 1fr) !important; }
    .three-col     { grid-template-columns: repeat(2, 1fr) !important; }
    .appt-grid     { grid-template-columns: 1fr !important; gap: 32px !important; }
    .hours-grid    { grid-template-columns: 1fr !important; gap: 40px !important; }
    .hours-divider { display: none !important; }
    .footer-grid   { grid-template-columns: 1fr 1fr !important; gap: 28px !important; }
    .rx-pad        { padding-left: 24px !important; padding-right: 24px !important; }
  }

  /* Large phone / small tablet portrait (≤ 768px) */
  @media (max-width: 768px) {
    .three-col { grid-template-columns: 1fr !important; }
    .two-col   { grid-template-columns: 1fr !important; }
    .rx-pad    { padding-left: 20px !important; padding-right: 20px !important; }
    /* Prevent iOS Safari auto-zoom on input focus */
    input, textarea, select { font-size: 16px !important; }
  }

  /* Phone (≤ 640px) */
  @media (max-width: 640px) {
    .stat-grid      { grid-template-columns: repeat(2, 1fr) !important; }
    .footer-grid    { grid-template-columns: 1fr !important; gap: 20px !important; }
    .form-grid      { grid-template-columns: 1fr !important; }
    .rx-pad         { padding-left: 16px !important; padding-right: 16px !important; }
    .stat-card-inner { padding: 28px 12px !important; }
    .stat-number    { font-size: clamp(22px, 8vw, 40px) !important; }
    .hero-cta-row > * { width: 100% !important; text-align: center !important; box-sizing: border-box !important; }
    .chat-panel     { max-width: calc(100vw - 48px) !important; }
  }
`;

function pageFromPath() {
  const path = window.location.pathname.replace(/^\//, "").replace(/\/$/, "") || "home";
  return ROUTES[path] ? path : "home";
}

export default function App() {
  const [page, setPage] = useState(pageFromPath);

  const navigate = (destination) => {
    setPage(destination);
    const url = destination === "home" ? "/" : `/${destination}`;
    window.history.pushState({ page: destination }, "", url);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Handle browser back/forward buttons
  useEffect(() => {
    const onPop = () => setPage(pageFromPath());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  useEffect(() => {
    document.title = page === "home"
      ? "Labarium Diagnostic Systems"
      : `${page.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ")} | Labarium`;
  }, [page]);

  // Global scroll-reveal observer — re-runs when page changes so new elements are picked up
  useEffect(() => {
    const timer = setTimeout(() => {
      const els = document.querySelectorAll(".reveal, .reveal-left, .reveal-right, .reveal-scale");
      const obs = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("visible"); }),
        { threshold: 0.12 }
      );
      els.forEach(el => obs.observe(el));
      return () => obs.disconnect();
    }, 50);
    return () => clearTimeout(timer);
  }, [page]);

  const PageComponent = ROUTES[page] || HomePage;

  return (
    <>
      <style>{GLOBAL_CSS}</style>
      <Navbar setPage={navigate} currentPage={page} />
      <main>
        <PageComponent setPage={navigate} />
      </main>
      <Footer setPage={navigate} />
      <ChatWidget />
    </>
  );
}
